<template>
  <div>
    <van-row class="bmTitle">
      <van-col span="24">
        <h2>{{ meetingName }}</h2>
      </van-col>
    </van-row>
    <van-row class="bmForm">
		
      <van-col span="24">
        <!-- <p style="text-align:center;margin:10px 0 14px;font-size: 20px;color:red;">订阅费</p> -->
        <van-form @submit="onSubmit">
			<h3 class="bmlcTit">填写发票信息 <van-icon class="iconfont" class-prefix="icon" name="bianji" size="24" color="#e5b91c" />
				<div style="float: right;">
				  <van-button round block  type="default" @click="shsq">稍后申请</van-button>
				</div>
			</h3>
          <div class="formInput hide"><van-field v-model="invoiceType" name="invoiceType" label="id" /></div>
          <!-- <div class="formInput">
            <van-field name="invoiceType" label="发票类型" required v-if="this.zsbxy == false">
              <template #input>
                <van-radio-group v-model="invoiceType" direction="horizontal">
                  <van-radio name="1">增值税普通发票</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field name="invoiceType" label="发票类型" v-else-if="this.zsbxy == true">
              <template #input>
                <van-radio-group v-model="invoiceType" direction="horizontal">
                  <van-radio name="1">增值税普通发票</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div> -->
          <div class="formInput">
            <van-field
              v-if="this.zsbxy == false"
              v-model="invoiceTitle"
              name="invoiceTitle"
              placeholder="请填写发票抬头"
              label="发票抬头"
              clearable
              required
              :rules="[{ required: true, message: '请填写发票抬头' }]"
            />
            <van-field
              v-else-if="this.zsbxy == true"
              v-model="invoiceTitle"
              name="invoiceTitle"
              placeholder="请填写发票抬头"
              label="发票抬头"
              clearable
              :rules="[{ required: false, message: '请填写发票抬头' }]"
            />
          </div>
          <div class="formInput">
            <van-field
              v-if="this.zsbxy == false"
              v-model="taxpayerIdentificationNumber"
              name="taxpayerIdentificationNumber"
              placeholder="请填写税务登记号"
              label="税务登记号"
              clearable
              required
              :rules="[{ required: true, message: '请填写税务登记号' }]"
            />
            <van-field
              v-else-if="this.zsbxy == true"
              v-model="taxpayerIdentificationNumber"
              name="taxpayerIdentificationNumber"
              placeholder="请填写税务登记号"
              label="税务登记号"
              clearable
              :rules="[{ required: false, message: '请填写税务登记号' }]"
            />
          </div>
          <div class="formInput">
            <van-field
              v-model="bankOfDeposit"
              name="bankOfDeposit"
              placeholder="请填写开户银行名称"
              label="开户银行名称"
              clearable
            />
          </div>
          <div class="formInput">
            <van-field
              v-model="accountOpening"
              name="accountOpening"
              placeholder="请填写基本开户账号"
              label="基本开户账号"
              clearable
            />
          </div>
          <div class="formInput">
            <van-field
              v-model="companyAddress"
              name="companyAddress"
              placeholder="请填写注册场所地址"
              label="注册场所地址"
              clearable
            />
          </div>
          <div class="formInput">
            <van-field
              v-model="contactTelephoneCompany"
              name="contactTelephoneCompany"
              placeholder="请填写注册固定电话"
              label="注册固定电话"
              clearable
            />
          </div>
          <div class="formInput">
            <van-field
              v-if="this.zsbxy == false"
              v-model="recipientEmail"
              name="recipientEmail"
              placeholder="请输入发票收件人邮箱"
              label="发票收件人邮箱"
              clearable
              required
              :rules="[{ pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, required:true, message: '请输入正确发票收件人邮箱'}]"
            />
            <van-field
              v-else-if="this.zsbxy == true"
              v-model="recipientEmail"
              name="recipientEmail"
              placeholder="请输入发票收件人邮箱"
              label="发票收件人邮箱"
              clearable
            />
          </div><!--
          <div class="formInput" style="padding:20px 0;">
                  <van-checkbox v-model="zsbxy" shape="square">暂时不需要 <b style="color:red;">可登录个人中心重新申请发票</b></van-checkbox>
          </div> -->
          <div style="margin:30px 16px 16px;">
            <van-button round block  type="info" native-type="submit">下一步</van-button>
          </div>
          <!-- <div style="margin:20px 16px 16px;">
            <van-button round block  type="default" @click="shsq">稍后申请</van-button>
          </div> -->
        </van-form>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      meetingName: this.$cookies.get('meetingName'),
      invoiceType:1,
      invoiceTitle:'',//发票抬头
      taxpayerIdentificationNumber:'',//税务登记号
      bankOfDeposit:'',//开户银行名称
      accountOpening:'',//基本开户账号
      companyAddress:'',//注册场所地址
      contactTelephoneCompany:'',//注册固定电话
      recipientEmail:'',//发票收件人邮箱
      zsbxy:false
    };
  },
  methods: {
    shsq(){
      this.zsbxy = true;
    },
    onSubmit(values) {
      const formValue = JSON.parse(sessionStorage.getItem('values'));
      formValue.isCharge = 1;

      if(this.zsbxy == false){
        formValue.isInvoce = 1;
        formValue.invoiceInfo = values;
        if (this.invoiceType == -1) {
          this.$toast.fail('请选择发票类型');
          return false;
        } else{
          formValue.invoiceInfo.invoiceType = parseInt(formValue.invoiceInfo.invoiceType);
        }
      }
	  formValue.attr2 = sessionStorage.getItem('meetingWyxf');
      this.axios.post('/api/appweb/entered/fromAdd', formValue).then(res => {
        if (res.data.status == 200) {
          //订单报名费
          var userOrderInfo = res.data.data;
          var payMoney = userOrderInfo.payMoney;
          if (payMoney) {
              this.$cookies.set("cookies_meeting_order_payMoney", payMoney);
          }
          //订单号
          var outTradeNo = userOrderInfo.outTradeNo;
          if (outTradeNo) {
              this.$cookies.set("cookise_order_outTradeNo", outTradeNo);
          }
          //订单id
          var meetingPayorderId = userOrderInfo.meetingPayorderId;
          if (meetingPayorderId) {
              this.$cookies.set("cookies_meeting_order_key", meetingPayorderId);
          }
            this.$router.push('/charge/pay');
        } else {
          if (res.data.msg) {
            this.$toast.fail(res.data.msg);
          } else if(res.data.status == -1){
            this.$toast.fail(res.data.message);
          }
          else {
            this.$toast.fail(res.data.result.users[0].msg);
          }
        }
      })

    }
  }
};
</script>

<style>
.bmlcTit {
	font-size: 20px;
	font-weight: bold;
	margin-top: 0;
	margin-bottom: 20px;
	margin-left: 20px;
	margin-right: 20px;
	color: #0038b8;
	line-height: 40px;
}
.bmlcTit button{vertical-align: middle;}
.bmForm {
  padding: 20px 0;
}
.bmTitle {
  padding: 10px 20px 30px;
  line-height: 40px;
  background: url(~@/assets/images/titlebg.png) no-repeat bottom center;
  background-size:  100% 100%;
  color:#fff;
  text-align: center;
}
.bmTitle h2 {
  font-weight: normal;
  margin-bottom: 0;
}
.hide {
  display: none;
}
.formInput {
  padding: 4px 0;
  margin:0 20px;
  border-bottom: 1px solid #e8e8e8;
}
.lineddd{
  height:3px;
  background-color: #e8e8e8;
  margin-top: -1px;
}
</style>



// WEBPACK FOOTER //
// src/components/Fpgl/index.vue